import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1009,
	height: 541,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			d: "M107.1 161h371.7c22 0 40 18 40 40v194.2H107V161Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M107.1 161h8.6a40 40 0 0 1 40 40v339.2h-48.6V161Zm834.6 292.2h48.6v87h-48.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			d: "M372 395.2h603a34 34 0 1 1 0 68H372v-68Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M124.1 395.2h603a34 34 0 1 1 0 68H124v-68Zm554.3 68H727v77h-48.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#99B7E7",
			d: "M188.4 386.4c-26.6-15-27.4-56.2-26-76.8a17 17 0 0 1 12.8-15.3c23.9-6.6 79.5-18.6 112-.7 20.6 11.5 49.6 38.8 70 59.3a18.5 18.5 0 0 1-10.1 31.4c-46.8 8-128.7 18.9-158.7 2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#99B7E7",
			d: "M273.2 376.1a12.5 12.5 0 0 1-5.8-8.2c-1.5-7.4 6.8-11.9 14.3-11a77.2 77.2 0 0 1 29 8c11.1 7.1 1.4 21.3-11.6 19a80.3 80.3 0 0 1-25.9-7.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			d: "M0 360h85v180H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			stroke: "#031839",
			strokeWidth: 8.3,
			d: "M89.2 364.1h119.7v171.7H89.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeWidth: 8.3,
			d: "M91.7 418.6h116.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#99B7E7",
			strokeWidth: 8.3,
			d: "M134.6 379h30.9m-30.9 56.1H166"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 126,
			height: 61,
			x: 30,
			y: 299,
			fill: "#095B92",
			rx: 8
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 126,
			height: 61,
			x: 40,
			y: 299,
			fill: "#416AAB",
			rx: 8
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			d: "M0 360h85v180H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			stroke: "#031839",
			strokeWidth: 8.3,
			d: "M89.2 364.1h119.7v171.7H89.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeWidth: 8.3,
			d: "M91.7 418.6h116.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#99B7E7",
			strokeWidth: 8.3,
			d: "M134.6 379h30.9m-30.9 56.1H166"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 126,
			height: 61,
			x: 40,
			y: 299,
			fill: "#18A0FB",
			rx: 8
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 100,
			height: 33,
			x: 53,
			y: 307,
			fill: "#095B92",
			rx: 4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 56,
			cy: 349,
			r: 3,
			fill: "#095B92"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 66,
			cy: 349,
			r: 3,
			fill: "#095B92"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 76,
			cy: 349,
			r: 3,
			fill: "#095B92"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 86,
			cy: 349,
			r: 3,
			fill: "#095B92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M728.6 328.1a64 64 0 0 0-25-28.7c-.6-.3-1.3-.4-2-.3L623 318h-1c-5.3-.6-54.8-6.6-82 6a152 152 0 0 0-23.4 15l-38.4 29.4c-2 1.6-1 4.7 1.6 4.7h254.7c1.6 0 2.8-1.3 2.6-2.8-1.6-17.1-1.7-24.4-8.5-42.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFCAAE",
			d: "m647.2 157.5 43-7.9-14.3 38.7-32.7-12 4-18.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFA879",
			d: "m647.2 154.2 28-.2 4.5 6.4s-17 8-22.7 7.3c-4.8-.6-10.9-5-10.9-5l1.1-8.5Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 667,
			cy: 108,
			fill: "#FFCAAE",
			rx: 36.1,
			ry: 45.8,
			transform: "rotate(14 667 108)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M679.6 103.1c11.5 2 15.6-11.9 15.6-11.9s7.3 6 5.4 20.2c-.8 6.3 4 3.8 4 3.8s13.8-16.6 7.2-32c-4.2-9.9-8.4-6.8-16.2-14-7-6.5-6-11.6-17.2-16.3-8.2-3.3-21.9-11.2-27.8-4.3-2.4 2.9-.5 4.6-3.3 7.1-4.5 4-10.4 1.1-11.5 8.6-.5 3.4-1 3.3-2.1 6.5-22.2 61.7 8.6 73.2 8.6 73.2s3.3-7.1 10.8-15c5.7-6 13.8-28 26.5-25.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB893",
			d: "M673.6 115.8c-2 2.7-4 8-6.4 6-2.4-2-2-8.4 1-12 3-3.5 7.3-4.7 9.7-2.7 2.4 2-2 5.7-4.3 8.7Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 667.4,
			cy: 108.6,
			fill: "#FFCAAE",
			rx: 44.5,
			ry: 56.5,
			transform: "rotate(14 667.4 108.6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M684 78.5c14 2.4 14.1-6 14.1-6s13.1 22.9 10.8 40.3c-1 7.8-5.1 22.3-5.1 22.3s27-38 18.9-57.2c-5.2-12-10.4-8.3-20-17.3-8.5-7.8-7.3-14.2-21.2-20-10-4.1-27-13.8-34.3-5.3-3 3.6-.6 5.7-4 8.8-5.6 4.9-13 1.3-14.3 10.6-.6 4.2-3.4 3.9-2.6 8 4 19.6-1.5 32-1.5 32s1.8-3.9 11.2-13.6c7-7.3 32.3-5.3 48-2.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#FFA879",
			strokeLinecap: "round",
			strokeWidth: 1.7,
			d: "M654.2 118.1c-3.8 2-10.8 1.3-10.6 4.6.2 4.2 7.1 5 7.1 5m2.6 21.4s5.3-6.5 4.5-9.3c-1-3-9.3-5-9.3-5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 2.5,
			d: "M679.4 116.5s-2.1-6-5.8-6.7c-3.3-.5-6.8 3.3-6.8 3.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 1.7,
			d: "M689 101.8s-4.8-3.1-10.5-4.5c-5-1.2-9-.7-9-.7m-14-5.4s-5-3.2-10.6-4.6c-5-1.2-9-.7-9-.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 2.5,
			d: "M648.5 106.7s-2-6-5.7-6.7c-3.2-.5-6.6 3.4-6.6 3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFCAAE",
			d: "M710.7 137.9c-3.7 4.4-9.6 6.7-12.5 4.2-3-2.5-2.5-10.3 1.2-14.7 3.6-4.3 9-5.9 12-3.4 3 2.5 3 9.5-.7 13.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFA879",
			d: "M655.4 146.7c-2.6 3.2-1-4-2.6-6.3-1.5-2.3-2-3.2-4-4.9 1.5-1 6.4 1.6 8 4 1.5 2.3 0 6.2-1.4 7.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFCAAE",
			d: "M523.8 34.1H534l34.8 38 19.7 39.8 31.8 47.6-23.7 14s-26.7-40.4-42.3-67.2c-14.3-24.6-30.5-72.2-30.5-72.2Zm291.5 47.1-9.6-7-41.6 36.2-26.6 35.4-40.1 41 20.8 18s33.6-34.8 53.9-58.2c18.6-21.6 43.2-65.4 43.2-65.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "M616 148.6s27 29.2 50 33.3c23.7 4.3 41.6-5.7 41.6-5.7l14 31.8-16.6 17.4V270l10.5 39.7-100 13.8a4 4 0 0 1-4.4-2.9c-3.3-12.2-14.4-54.9-14.4-72.5 0-23.5 9.5-52.2 9.5-52.2l-14.1-26 24-21.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFCAAE",
			d: "M518.9 8c1-2.3 3-5.2 4-6.5.3-.5.9-.8 1.5-1 1.7-.2 3 1.4 2.6 3l-2.2 7.6c-.1.5.4 1 1 .7l8.4-4c1.3-.7 3-.1 3.5 1.2l7.6 17c.5 1 .2 2.4-.8 3.1l-8.7 6.5c-.4.3-1 .5-1.5.5h-8.5c-.9 0-1.7-.4-2.2-1.1l-6.8-9.9c-.3-.4-.5-1-.5-1.4A47 47 0 0 1 518.9 8Zm281.4 54 2.9 13.8c.1.6.5 1.2 1 1.6l7.4 5.4c1 .7 2.3.6 3.2-.2l3.5-3c.6-.4 1-1.2 1-2V66.9c0-.6.2-1.2.6-1.7l2.2-2.4c.4-.4.6-1 .6-1.7v-5.6c0-.7-.2-1.4-.7-1.9l-.8-.8c-.6-.5-.6-1.4-.2-2.1.8-1.2 0-2.7-1.5-2.7h-2.4c-.4 0-.8 0-1.1-.2l-3.6-1.8a7.9 7.9 0 0 0-9.5 2.2l-2.4 2.9a7.9 7.9 0 0 0-1.4 7.4l1.2 3.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#99B7E7",
			d: "M451.4 335c54.6 7.1 97.4 6.8 156.5 7.3 39.9.3 85.8-5.9 115.4-10.7 20-3.3 40.7-1.4 59.4 6.5l125.3 53s-78.6 8.6-115.5 32.1c-22.7 14.5-84.8 42.3-111.6 48.9-93.5 23-284-41.3-327.2-63.9-23.8-12.4 48.7-79.5 97.7-73.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B7CCED",
			d: "M366 394.6c5.8-1 11.7 0 17.2 2 29.4 10.6 129.2 45.4 200.3 52.9 29.9 3.1 47 7.2 77 4.6 49-4.2 116.9-40.3 116.9-40.3s34.8-18.6 60-23.5c27-5.2 71 0 71 0s-78.6 8-115.5 29.8c-22.7 13.4-84.8 39.2-111.5 45.3-93.4 21.4-283.7-38.3-327-59.2-13.4-6.5 1-10 11.5-11.6Z"
		})
	]
});
const SvgBed2 = styled(base)({});
export default SvgBed2;
